import React, { useEffect, useMemo } from "react";
import { Logo } from "../assets/icons/Icons";
import { useUserData } from "../lib/contexts/UserContext";
import HospitalCard from "../components/HospitalCard";
import Loader from "../components/Loader";
import { useHospDocData } from "../lib/contexts/HospitalDoctorContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { HiArrowLeft } from "react-icons/hi2";

const ChooseDoctors = () => {
  const { userData } = useUserData();
  const { hospitalID, allDoctorsData, doctors, setDoctors } = useHospDocData();
  const navigate = useNavigate();

   useEffect(() => {
     setDoctors([]);
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

  const sortedDoctors = useMemo(() => {
    if (!allDoctorsData) return [];
    // Create a shallow copy to sort safely
    return [...allDoctorsData].sort((a, b) => {
      // Cast to 'any' to access 'is_active' if type definition is strict
      const a_active = (a as any).is_active === true ? 1 : 0;
      const b_active = (b as any).is_active === true ? 1 : 0;
      // Sorts active (1) before inactive (0)
      return b_active - a_active;
    });
  }, [allDoctorsData]);

  return (
    <>
     {doctors && doctors.length > 0 && (
        <div className="fixed bottom-0 left-0 right-0 w-full bg-gradient-to-t from-white to-transparent h-32 flex items-center justify-center z-10">
          <button
            className="bg-[#0F3CBE] text-white shadow-md rounded-lg hover:opacity-70 px-5 py-2 z-10"
            onClick={() => {
              if (doctors.length < 2)
                toast.error("Please select more than 1 doctor.");
              else{
                try{
                  localStorage.setItem('recentColumnViewDoctors', JSON.stringify(doctors));
                  navigate("/" + hospitalID + "/column-view");
                } catch(error){
                  console.error("Failed to save doctors to localstorage:", error);
                  toast.error("Could not save session");
                }
                // Navigate to column-carousel-view if more than 3 doctors, otherwise column-view
                if (doctors.length > 3) {
                  navigate("/" + hospitalID + "/column-carousel-view");
                } else {
                  navigate("/" + hospitalID + "/column-view");
                }
              }
            }}
          >
            Next -{">"}
          </button>
        </div>
      )}
      <div className=" flex justify-start bg-white shadow-md cursor-pointer 
             hover:bg-blue-500 hover:text-white transition-all duration-200 p-2 h-10 w-10 m-4 items-center rounded-full"
            onClick={() => navigate("/" + hospitalID)}
      >
        <HiArrowLeft
          className="w-6 h-6 text-blue-500" 
          style={{ color: 'inherit' }} // This ensures the 'hover:text-white' from parent works
        />
      </div>
      <div className="flex flex-col w-full justify-center items-center pt-6 pb-40">
        <Logo />
        <p className="font-semibold text-dark text-lg md:text-2xl lg:text-3xl mt-12 mb-5">
          Choose doctors
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  xl:grid-cols-3 gap-7 mb-16">
          {/* Create constant */}
          {sortedDoctors?.map((doctor) => {
            const selectionIndex = doctors?.findIndex(d => d.doctor_id === doctor.doctor_id) ?? -1;
            // ✅ Add 1 to the index to get the display number (1, 2, 3...)
            const selectionNumber = selectionIndex > -1 ? selectionIndex + 1 : undefined;
            return(
            <HospitalCard
              key={doctor.doctor_id}
              logo={doctor.profile_picture}
              name={doctor.full_name}
              qualification={doctor.qualification}
              specialization={doctor.specialization}
              is_active={doctor.is_active}
              selectionNumber={selectionNumber}
              docCount={"none"}
              gender={doctor.gender}
              hide_from_tv={doctor.hide_from_tv}
              show_name_prefix={doctor.show_name_prefix !== false}
              selected={doctors?.some(d => d.doctor_id === doctor.doctor_id) ?? false}
              handlePress={() => {
                console.log(doctor.full_name);
                setDoctors((prevDoctors = []) => {
                  // Check if the doctor is already in the array
                  const isDoctorPresent = prevDoctors.some(
                    (d) => d.doctor_id === doctor.doctor_id
                  );
                  // If not present, add the doctor to the array
                  if (!isDoctorPresent) {
                    return [...prevDoctors, doctor];
                  }
                  return prevDoctors.filter((e)=>e.doctor_id!==doctor.doctor_id);
                });
              }}
            />
          )})}
        </div>
       

        {userData === undefined && <Loader />}
      </div>
    </>
  );
};

export default ChooseDoctors;
